import { net } from "../store.js";
import { EXTRACTION_COLOR } from "../theme.js";

/** Extraction objective banner (phases: 1 open, 2 active, 3 success, 4 failed). */
export function ExtractionBanner() {
  const n = net.value;
  if (n === null || n.extractionPhase === 0) return null;
  const phase = n.extractionPhase;
  const color = EXTRACTION_COLOR[phase] ?? "#55ccff";
  const pct = Math.round((n.extractionHoldPct / 255) * 100);
  const text =
    phase === 1
      ? "Extraction open — stand in the zone to begin the hold"
      : phase === 2
        ? `Extracting — hold the zone (${pct}%)`
        : phase === 3
          ? "Extracted! Relic secured — survive to victory to keep it"
          : "Extraction failed";
  return (
    <div
      class="absolute top-16 left-1/2 -translate-x-1/2 rounded-lg border bg-panel/85 px-4 py-1.5 text-center font-bold"
      style={{ borderColor: color, color }}
    >
      {text}
      {phase === 2 && (
        <div class="mt-1 h-1.5 w-56 overflow-hidden rounded-full bg-white/10">
          <div
            class="h-full transition-[width] duration-150"
            style={{ width: `${pct}%`, background: color }}
          />
        </div>
      )}
    </div>
  );
}
